export function normalize(str: string): string {
  return str
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u{1F300}-\u{1F9FF}]/gu, '') // emojis (emoticons, symbols, pictographs)
    .replace(/[\u{2600}-\u{27BF}]/gu, '') // emojis (miscellaneous symbols, dingbats)
    .replace(/[\u{FE00}-\u{FEFF}]/gu, '') // variation selectors and control characters
    .replace(/[\u0300-\u036f]/g, '') // diacritics
    .replace(/æ/g, 'ae')
    .replace(/œ/g, 'oe')
    .replace(/ß/g, 'ss')
    .replace(/ø/g, 'o')
    .replace(/ł/g, 'l')
    .replace(/-/g, ' ')
    .trim()
}
